var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('wrap',{ref:"wrap",attrs:{"title":_vm.title}},_vm._l((_vm.data),function(week,index){return _c('c-table',{key:'week' + index,staticClass:"table",attrs:{"head":_vm.head,"body":week.body}})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3dcc28e3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/QC34.vue
// module id = null
// module chunks = 